import { IsNotEmpty, IsUUID } from 'class-validator';

import { FormAttributesRequest } from '../../types';
import { NOT_EMPTY_OPTIONS } from '../../constants';

export class GenerateDocumentDto {
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  eventId: string;

  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  @IsUUID()
  nodeId: string;

  attributes?: FormAttributesRequest;

  documentDate?: string;

  documentNumber?: string;
}
